import { isSmokeTestSquadName } from './year2Ui';

export const DEFAULT_SQUAD_NAMES = ['Squad A', 'Squad B', 'Squad C', 'Squad D'];

export function requiredSquadCount(studentCount) {
  if (studentCount > 20) return 0;
  return studentCount <= 15 ? 3 : 4;
}

export function isBlockedCohort(studentCount) {
  return studentCount > 20;
}

export function formatSetupStatus(status) {
  const labels = {
    not_started: 'Not Started',
    draft: 'Draft',
    finalized: 'Finalized',
    blocked: 'Blocked',
  };
  return labels[status] || status;
}

export function formatStatusSummary(summary = {}) {
  const parts = [];
  if (summary.not_started) parts.push(`${summary.not_started} Not Started`);
  if (summary.draft) parts.push(`${summary.draft} Draft`);
  if (summary.finalized) parts.push(`${summary.finalized} Finalized`);
  if (summary.blocked) parts.push(`${summary.blocked} Blocked`);
  return parts.length ? parts.join(', ') : 'No cohorts';
}

export function buildEmptySquadSlots(required) {
  return Array.from({ length: required }, (_, index) => ({
    id: null,
    slot_index: index,
    name: DEFAULT_SQUAD_NAMES[index] || `Squad ${index + 1}`,
    name_locked: false,
    topic: '',
    status: 'draft',
    member_ids: [],
  }));
}

export function mergeSetupSquads(apiSquads, required, allowedStudentIds = null) {
  const slots = buildEmptySquadSlots(required);
  const allowed = allowedStudentIds == null
    ? null
    : new Set((allowedStudentIds || []).map(String));

  (apiSquads || []).forEach((squad, index) => {
    if (index < required) {
      const memberIds = (squad.member_ids || [])
        .map(String)
        .filter((id) => !allowed || allowed.has(id));

      slots[index] = {
        id: squad.id ?? null,
        slot_index: squad.slot_index ?? index,
        name: (squad.name && !isSmokeTestSquadName(squad.name)) ? squad.name : slots[index].name,
        name_locked: Boolean(squad.name_locked),
        topic: squad.topic || '',
        status: squad.status || 'draft',
        member_ids: memberIds,
      };
    }
  });
  return slots;
}

export function autoDistributeStudents(unassignedIds, squads) {
  const next = squads.map((squad) => ({
    ...squad,
    member_ids: [...(squad.member_ids || []).map(String)],
  }));
  const queue = [...unassignedIds.map(String)];

  while (queue.length > 0) {
    let minIndex = 0;
    for (let i = 1; i < next.length; i += 1) {
      if (next[i].member_ids.length < next[minIndex].member_ids.length) {
        minIndex = i;
      }
    }
    const studentId = queue.shift();
    next[minIndex].member_ids.push(studentId);
  }

  return next;
}

export function findDuplicateTopics(squads) {
  const seen = new Map();
  const duplicates = [];
  squads.forEach((squad) => {
    const topic = (squad.topic || '').trim();
    if (!topic) return;
    if (seen.has(topic)) {
      if (!duplicates.includes(topic)) duplicates.push(topic);
    } else {
      seen.set(topic, true);
    }
  });
  return duplicates;
}

export function assignedStudentMap(squads) {
  const map = new Map();
  squads.forEach((squad, index) => {
    (squad.member_ids || []).forEach((studentId) => {
      map.set(String(studentId), index);
    });
  });
  return map;
}